import React from 'react';

const SignalPage = () => (
  <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', background: 'var(--background-color, #f8f9fa)' }}>
    <img 
      src="/images/signal.png" 
      alt="Signal logo" 
      style={{ maxWidth: 200, marginBottom: 24 }}
    />
    <a 
      href="https://signal.group/#CjQKICKwQuqOAdJX5ugq8IQyuNNEbHyEz-PGOYq1GiNmZKqQEhCLAuVFLlawmNEfWkvI41Cu" 
      target="_blank" 
      rel="noopener noreferrer"
      style={{ fontSize: 18, color: '#3a76f0', wordBreak: 'break-all' }}
    >
      Join our Signal group
    </a>
  </div>
);

export default SignalPage; 